var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionsSettingsOpener(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H6C7.103 0 8 0.897 8 2V6C8 7.103 7.103 8 6 8H2C0.897 8 0 7.103 0 6V2C0 0.897 0.897 0 2 0ZM12 0H16C17.103 0 18 0.897 18 2V6C18 7.103 17.103 8 16 8H12C10.897 8 10 7.103 10 6V2C10 0.897 10.897 0 12 0ZM6 10H2C0.897 10 0 10.897 0 12V16C0 17.103 0.897 18 2 18H6C7.103 18 8 17.103 8 16V12C8 10.897 7.103 10 6 10ZM12 10H16C17.103 10 18 10.897 18 12V16C18 17.103 17.103 18 16 18H12C10.897 18 10 17.103 10 16V12C10 10.897 10.897 10 12 10Z",
    fill: "#B0B3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionsSettingsOpener);
export default __webpack_public_path__ + "static/media/sectionsSettingsOpener.d06da2988b07cebb415791c9695af682.svg";
export { ForwardRef as ReactComponent };